import { sendPost } from '@utils/request';
import { getUserCenterParams } from '@/utils/index';
// 获取用户地址列表
export function getAddressList2(data) {
  const url = '/address/userNewAddressContract/queryUserAddressList';
  return sendPost({ url, data });
}

// 个人中心的地址接口
export function fetchAddressList(data) {
  const url = '/address/userNewAddressContract/queryUserAddressList';
  return sendPost({ url, data });
}

export function fetchAddressUpdate(data) {
  const url = '/address/userNewAddressContract/update';
  return sendPost({ url, data, specielApi: true });
}

export function fetchAddressCreate(data) {
  const url = '/address/userNewAddressContract/creat';
  return sendPost({ url, data, specielApi: true });
}

export function fetchAddressDelete(data) {
  const url = '/address/userNewAddressContract/deleteUserAddress';
  return sendPost({ url, data, specielApi: true });
}

// 新增收货地址确认
export function getNewAddAddress(data) {
  const url = '/address/userNewAddressContract/creat';
  return sendPost({ url, data });
}

// 删除地址列表中的收货地址
export function getDelAddress(data) {
  const url = '/address/userNewAddressContract/deleteUserAddress';
  return sendPost({ url, data });
}

// 编辑收货地址确认
export function getEditAddress(data) {
  const url = '/address/userNewAddressContract/update';
  return sendPost({ url, data });
}

// 修改运单配送地址
export function fetchUpdateAddressDelivery(data) {
  const url = '/tradeDeliveryOrderAddress/updateOrderAddressInfo';
  return sendPost({
    url,
    data,
    method: 'POST',
    baseURL: true,
    applicationType: true,
    deleteFalsyProp: true,
    Business: true,
    specielApi: true,
  });
}

// 查询地址是否在疫区
export function fetchAddressAreaLimit(data) {
  const url = '/trade/special/arealimit';
  return sendPost({ url, data });
}

// 根据id获取地址详细信息
export function getAddressDetails(data) {
  const url = '/address/userNewAddressContract/findUserAddressByIdAndUserId';
  return sendPost({ url, data });
}

// 获取全国各省数据
export function getProvince(data) {
  const url = '/trade/addressContract/getAllDistrict';
  return sendPost({ url, data });
}

// 获取某一省各城市数据
export function getCitiesByProvince(data) {
  const url = '/trade/addressContract/getAllCityByProvince';
  return sendPost({ url, data });
}

// 获取某省某市下的所有区县
export function getRegionsByCity(data) {
  const url = '/trade/addressContract/getAllRegionByCity';
  return sendPost({ url, data });
}

// 获取某省某市某区县下的所有街道
export function getStreetByRegion(data) {
  const url = '/trade/addressContract/getAllStreetByRegion';
  return sendPost({ url, data });
}

// 获取用户中心用户地址列表
export function getUserAddressList(data = {}) {
  const url = '/user/receiveaddress/external/getlist';
  return sendPost({ url, data: getUserCenterParams(data) });
}
// 更新用户中心用户地址
export function fetchUserAddressUpdate(data = {}) {
  const url = '/user/receiveaddress/external/modify';
  return sendPost({ url, data: getUserCenterParams(data) });
}
// 根据id获取用户中心用户地址
export function getUserAddressDetails(data) {
  const url = '/user/receiveaddress/external/query';
  return sendPost({ url, data: getUserCenterParams(data) });
}
// 新增用户中心用户地址
export function getNewUserAddAddress(data) {
  const url = '/user/receiveaddress/external/create';
  return sendPost({ url, data: getUserCenterParams(data) });
}
// 删除用户中心用户地址
export function getUserDelAddress(data) {
  const url = '/user/receiveaddress/external/delete';
  return sendPost({ url, data: getUserCenterParams(data) });
}

// 获取全国各省数据
export function getNewProvince(data) {
  const url = '/position/address/getDistrictList';
  return sendPost({ url, data: getUserCenterParams(data) });
}

// 获取某一省各城市数据
export function getNewCitiesByProvince(data) {
  const url = '/position/address/getCityList';
  return sendPost({ url, data: getUserCenterParams(data)  });
}

// 获取某省某市下的所有区县
export function getNewRegionsByCity(data) {
  const url = '/position/address/getRegionList';
  return sendPost({ url, data: getUserCenterParams(data)  });
}

// 获取某省某市某区县下的所有街道
export function getNewStreetByRegion(data) {
  const url = '/position/address/getStreetList';
  return sendPost({ url, data: getUserCenterParams(data) });
}
// 验证是否限制城市
export function checkAddress(data) {
  const url = '/union/config/getUnionPlatformCity';
  return sendPost({ url, data: getUserCenterParams(data) });
}
